import { useFetch } from 'hooks'

import { LoadingBox, TransferList } from 'components'
import { Grid, Typography } from '@material-ui/core'

import * as service from 'service'

const DepartmentSelect = ({ companyId, show }) => {
  const { response, isLoading } = useFetch(
    service.dponet.departments.get,
    { companyId, active: true, minimal: true, perPage: 99999 },
    [companyId],
    !!companyId,
  )

  if (!show) return <></>

  if (!companyId) {
    return <Typography color="error">Selecione uma empresa origem</Typography>
  }

  if (isLoading) {
    return <LoadingBox minHeight={400} />
  }

  return (
    <Grid item xs={12}>
      <TransferList leftItens={response?.data?.departments} rightItens={[]} />
    </Grid>
  )
}

export default DepartmentSelect
